import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Cache the status across the app so every consumer shares one fetch.
let _cache = null;
let _fetchedAt = 0;
let _inflight = null;
const TTL_MS = 60_000; // 60s — plenty for a UI signal that changes rarely.

async function fetchStatus() {
  const now = Date.now();
  if (_cache && now - _fetchedAt < TTL_MS) return _cache;
  if (_inflight) return _inflight;
  _inflight = axios
    .get(`${API_URL}/api/competitions/status`, { withCredentials: true })
    .then((res) => {
      _cache = res.data;
      _fetchedAt = Date.now();
      _inflight = null;
      return _cache;
    })
    .catch(() => {
      _inflight = null;
      // Fail-open: assume nothing is closed so UI stays functional.
      return { active_sports: ['AFL', 'NRL', 'EPL', 'WC'], closed_sports: [], active: [], closed: [] };
    });
  return _inflight;
}

export default function useCompetitionStatus() {
  const [status, setStatus] = useState(_cache);
  useEffect(() => {
    let cancelled = false;
    fetchStatus().then((s) => { if (!cancelled) setStatus(s); });
    return () => { cancelled = true; };
  }, []);
  return status;
}
